<template>
  <div class="dialog">
    <el-dialog title="领导评价" :visible.sync="teacherEvaluationShow" width="1000px" :before-close="dialogClose"
      @open="dialogOpen">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm"
        label-position="left" :inline="true">
        <el-form-item label="选择学年:" prop="schoolYear">
          <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYear" @change="schoolYearConfirm" />
        </el-form-item>
        <el-form-item label="选择学期:" prop="semester">
          <el-select v-model="ruleForm.semester" placeholder="请选择学期" style="width: 235px" @change="semesterConfirm">
            <el-option v-for="item in semesterList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <table border="1" style="width: 100%; text-align: center;">
        <thead>
          <tr>
            <th></th>
            <th>评价维度</th>
            <th>评价内容</th>
            <th style="width: 50px;">分值</th>
            <th>评分</th>
          </tr>
        </thead>
        <tbody>
          <!-- 整体规划评价 -->
          <template v-for="(item, index) in tableData.evaluationItems">
            <tr v-for="(dItem, dIndex) in item.dimensionArrays" :key="dItem.id">
              <td v-if="dIndex === 0" :rowspan="item.dimensionArrays.length">{{ item.evaluationItem }}</td>
              <td>{{ dItem.evaluationDimension }}</td>
              <td>{{ dItem.evaluationContent }}</td>
              <td>{{ dItem.evaluationScore }}</td>
              <td>
                <el-input v-model="dItem.evaluationStore" placeholder="请输入" style="width: 100px;"></el-input>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="form-btn">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'teacherEvaluationShow',
    'semesterList',
    'teacherEvaluationData'
  ],
  data() {
    return {
      tableData: [],
      ruleForm: {
        schoolYear: '',
        semester: '',
      },
      rules: {
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
      },
      input: ''
    };
  },
  mounted() {
    this.ruleForm.schoolYear = this.school.schoolYear;
    this.ruleForm.semester = this.school.semester;
    this.selectTutorEvaluationScaleList(); // 查询评定项目列表
  },
  methods: {
    // 开启弹窗
    dialogOpen() {
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:teacherEvaluationShow", false);
    },

    schoolYearConfirm(e) {
      this.selectTutorEvaluationDetailsList();
    },
    semesterConfirm(e) {
      this.selectTutorEvaluationDetailsList();
    },
    // 查询评定项目列表
    selectTutorEvaluationScaleList() {
      let data = {
        schoolId: this.school.id,
        evaluationBody: 1,
      };
      this.get(this.$url.selectTutorEvaluationScaleList, data).then(res => {
        // console.log("评定项目列表==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);

        // 初始化 tableData
        this.tableData = {
          teacherId: this.teacherEvaluationData.teacherId,
          teacherName: this.teacherEvaluationData.teacherName,
          schoolYear: this.ruleForm.schoolYear,
          semester: this.ruleForm.semester,
          evaluationItems: res.data.map(item => ({
            ...item,
            // 初始化 dimensionArrays
            dimensionArrays: item.dimensionArrays.map(dim => ({
              ...dim,
              dimensionId: dim.id, // 保存原始 id 为 dimensionId
              id: undefined, // 避免冲突，删掉或重命名
              evaluationStore: null,
              recordId: null // 用于保存数据库记录 ID
            }))
          }))
        };

        // 初始化完成后，加载历史评分
        this.selectTutorEvaluationDetailsList();
      });
    },
    // 查询评定量记录列表
    selectTutorEvaluationDetailsList() {
      let data = {
        schoolId: this.school.id,
        teacherId: this.teacherEvaluationData.teacherId,
        schoolYear: this.ruleForm.schoolYear,
        semester: this.ruleForm.semester,
        evaluationBody: 1,
      };
      this.get(this.$url.selectTutorEvaluationDetailsList, data).then(res => {
        // console.log("评定记录列表==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);

        const records = res.data;

        // 构建 map：evaluationItemId → record
        const recordMap = new Map(records.map(record => [record.evaluationItemId, record]));

        // 回填 + 清空逻辑
        this.tableData.evaluationItems.forEach(item => {
          item.dimensionArrays.forEach(dim => {
            const record = recordMap.get(dim.dimensionId); // 使用 dimensionId 匹配

            if (record) {
              dim.evaluationStore = record.evaluationStore;
              dim.recordId = record.id; // 保存数据库主键，不污染 dimensionId
            } else {
              dim.evaluationStore = null;
              dim.recordId = null; // 清空 recordId
            }
          });
        });
      });
    },
    confirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.ruleForm.schoolYear == '' || this.ruleForm.semester == '') return this.$message.warning("请选择学年学期");
          // 额外检查：所有 dimensionArrays 中的 evaluationStore 是否已填写
          let hasEmptyStore = false;
          const submitList = [];

          for (let item of this.tableData.evaluationItems) {
            // 判断 dimensionArrays 是否为数组
            if (Array.isArray(item.dimensionArrays)) {
              for (let subItem of item.dimensionArrays) {
                // 检查 evaluationStore 是否为空（null, undefined, ''）
                if (!subItem.evaluationStore || subItem.evaluationStore.toString().trim() === '') {
                  hasEmptyStore = true;
                  break;
                }

                // 组装提交数据
                submitList.push({
                  schoolId: this.school.id,
                  schoolName: this.school.schoolName,
                  schoolYear: this.ruleForm.schoolYear,
                  semester: this.ruleForm.semester,
                  teacherId: this.teacherEvaluationData.teacherId,
                  teacherName: this.teacherEvaluationData.teacherName,
                  evaluationItemId: subItem.dimensionId, // 提交维度ID, // 评分项 ID
                  evaluationStore: subItem.evaluationStore, // 评分值
                  evaluationBody: subItem.evaluationBody || '2' // 评分主体，如班主任、学生等，可从 item 或 subItem 获取
                });
              }
            }
            if (hasEmptyStore) break; // 提前退出
          }

          if (hasEmptyStore) {
            return this.$message.warning('请完善所有评分信息，不得为空');
          }

          // 所有检查通过，提交数据
          // console.log('评分完成', submitList);
          // 这里可以发送请求提交评分
          this.submitScores(submitList);
        } else {
          // 表单校验未通过（如其他字段规则不满足）
          this.$message.warning('请选择学年学期');
        }
      });
    },
    submitScores(data) {
      this.put(this.$url.editTutorEvaluationDetails, data).then(res => {
        // console.log("编辑评定记录==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacherEvaluation.scss";
</style>